import $ from 'jquery'; // eslint-disable-line
import mapStyles from './styles.json'; // The maps styles.

const distributorFinder = {
	isLoading: false,
	GoogleMapsApiLoader: false,
	googleApi: false,
	map: false,
	markers: [],
	zipCity: false,
	application: false,
	country: false,
	regionState: false,
	streetAddress: false,
	postalCode: false,
	latitude: false,
	longitude: false,
	dirty: false,
	mapDefaultCenterLatitude: 37.2582146,
	mapDefaultCenterLongitude: -104.654745,
	letters: new Array(26).fill(1).map((_, i) => String.fromCharCode(65 + i)),
	init() {
		$('body').on('click', '.js-df-search-use-location', (event) => {
			event.preventDefault();
			distributorFinder.handleGeolocation();
		});
	},
	updateDataFromReverseSearchRequest(response) {
		distributorFinder.isLoading = false;
		if (response
			&& typeof response.address !== 'undefined'
			&& typeof response.address.postcode !== 'undefined'
		) {
			if (typeof response.address.state !== 'undefined') {
				distributorFinder.regionState = response.address.state;
			} else if (typeof response.address.region !== 'undefined') {
				distributorFinder.regionState = response.address.region;
			} else {
				distributorFinder.regionState = response.address.county;
			}

			distributorFinder.country = response.address.country_code;
			distributorFinder.streetAddress = response.display_name;
			distributorFinder.postalCode = response.address.postcode;
		} else {
			distributorFinder.handleGeolocationMessages(DF.i18n.NoZipFound);
		}
	},
	distributorsApiSuccessEvent(collection, response) {
		distributorFinder.isLoading = false;
		distributorFinder.dirty = false;
		const itemsWrapper = $('#df-search-results-items');
		const foundItems = response.items;

		if (distributorFinder.map) {
			// Pan map to location.
			distributorFinder.map.panTo({
				lat: Number(distributorFinder.latitude),
				lng: Number(distributorFinder.longitude),
			});
		} else {
			// Initialize map.
			distributorFinder.map = new distributorFinder.googleApi.maps.Map(document.getElementById('df-search-results-map'), {
				center: {
					lat: Number(distributorFinder.latitude),
					lng: Number(distributorFinder.longitude),
				},
				zoom: 10,
				styles: mapStyles,
			});
		}

		if (!foundItems.length) {
			itemsWrapper.html(DF.i18n.NoResultsFound);
			$('.df-search-results-content-wrapper').addClass('df-no-results');
			return;
		}

		const zip = $('.df-filters-form').find('.zip_city_field input').val();
		$('#df-search-results-totals').text(zip);
		// Maybe remove the zip errors.
		$('.zip_city_field').find('.df-zip-error').remove();

		// Set the new collection items.
		collection.reset(foundItems);
		// Let's build the distributor list.
		const distributorsView = new DistributorsView({collection: Distributors});
		itemsWrapper.html(distributorsView.render().el);

		distributorFinder.googleApi.maps.event.addListenerOnce(distributorFinder.map, 'bounds_changed', (event) => {
			distributorFinder.map.setZoom(distributorFinder.map.getZoom() - 1);

			if (distributorFinder.map.getZoom() > 15) {
				distributorFinder.map.setZoom(15);
			}
		});

		let marker = false;
		const bounds = new distributorFinder.googleApi.maps.LatLngBounds();
		$(foundItems).each((index, distributor) => {
			const tag = distributorFinder.letters[index];
			marker = distributorFinder.createMarker(distributor, tag);
			distributorFinder.markers.push(marker);
			marker.addListener('click', distributorFinder.highlightDistributor);
			bounds.extend(marker.getPosition());

			// View on map on button click.
			const link = document.querySelector('#df-search-results-item-' + distributor.id + ' a.view_on_map');

			link.setAttribute('data-id', distributor.id);
			link.addEventListener('click', (e) => {
				e.preventDefault();
				const markers = distributorFinder.markers;
				const selectedEl = e.target;
				markers.forEach((marker) => {
					if (marker.resultId === selectedEl.getAttribute('data-id')) {
						distributorFinder.highlightDistributor(marker);
					}
				});
			});

		});

		distributorFinder.map.fitBounds(bounds);
	},
	createMarker(item, tag) {
		if (!distributorFinder.map && !distributorFinder.googleApi) {
			return false;
		}

		const pinSVGFilled = 'M 12,2 C 8.1340068,2 5,5.1340068 5,9 c 0,5.25 7,13 7,13 0,0 7,-7.75 7,-13 0,-3.8659932 -3.134007,-7 -7,-7 z';
		const labelOriginFilled = new distributorFinder.googleApi.maps.Point(12, 9);

		const markerImage = {
			anchor: new distributorFinder.googleApi.maps.Point(12, 17),
			fillColor: '#F58220',
			fillOpacity: 1,
			labelOrigin: labelOriginFilled,
			path: pinSVGFilled,
			scale: 2,
			strokeWeight: 0,
		};

		return new distributorFinder.googleApi.maps.Marker({
			resultId: item.id,
			icon: markerImage,
			label: {
				color: '#FFFFFF',
				text: tag,
			},
			map: distributorFinder.map,
			position: {
				lat: Number(item.latitude),
				lng: Number(item.longitude),
			},
		});
	},
	clearMarkers() {
		// Remove previously added markers.
		if (distributorFinder.markers) {
			Object.keys(distributorFinder.markers).forEach((i) => {
				distributorFinder.markers[i].setMap(null);
			});
		}
	},
	resetMarkersColor() {
		// Remove previously added markers.
		if (distributorFinder.markers) {
			Object.keys(distributorFinder.markers).forEach((i) => {
				const pinSVGFilled = 'M 12,2 C 8.1340068,2 5,5.1340068 5,9 c 0,5.25 7,13 7,13 0,0 7,-7.75 7,-13 0,-3.8659932 -3.134007,-7 -7,-7 z';
				const labelOriginFilled = new distributorFinder.googleApi.maps.Point(12, 9);

				const markerImage = {
					anchor: new distributorFinder.googleApi.maps.Point(12, 17),
					fillColor: '#F58220',
					fillOpacity: 1,
					labelOrigin: labelOriginFilled,
					path: pinSVGFilled,
					scale: 2,
					strokeWeight: 0,
				};
				distributorFinder.markers[i].setIcon(markerImage);
			});
		}
	},
	highlightDistributor(newMarker = '') {
		const itemId = newMarker.resultId ? newMarker.resultId : this.resultId;
		const pinSVGFilled = 'M 12,2 C 8.1340068,2 5,5.1340068 5,9 c 0,5.25 7,13 7,13 0,0 7,-7.75 7,-13 0,-3.8659932 -3.134007,-7 -7,-7 z';
		const labelOriginFilled = new distributorFinder.googleApi.maps.Point(12, 9);
		const markerImage = {
			anchor: new distributorFinder.googleApi.maps.Point(12, 17),
			fillColor: '#5493B3',
			fillOpacity: 1,
			labelOrigin: labelOriginFilled,
			path: pinSVGFilled,
			scale: 2,
			strokeWeight: 0,
		};
		const $itemsWrapper = document.querySelectorAll('#df-search-results-items .df-search-results-item');
		const $itemDiv = document.querySelector(`#df-search-results-item-${itemId}`);
		distributorFinder.resetMarkersColor();

		if (newMarker.resultId) {
			newMarker.setIcon(markerImage);
		} else {
			this.setIcon(markerImage);
		}


		// Remove all active items and add to the clicked one.
		$itemsWrapper.forEach((item) => {
			if (item.classList.contains('active')) { item.classList.remove('active'); }
		});

		$itemDiv.classList.add('active');
		// Scroll to the element.
		document.querySelector(`#df-search-results-item-${itemId}`).scrollIntoView({
			behavior: 'smooth',
			block: 'center',
		});
	},
	geolocationSuccess(position) {
		const lat = Number(position.coords.latitude);
		const long = Number(position.coords.longitude);

		distributorFinder.latitude = Number(position.coords.latitude);
		distributorFinder.longitude = Number(position.coords.longitude);

		// Get the reverse search for the postal code from OSM (OpenStreetMap).
		$.ajax({
			url: `${DF.OSMGeocodeAPI}&lat=${lat}&lon=${long}&zoom=17`,
		})
			.done((response) => {
				distributorFinder.updateDataFromReverseSearchRequest(response);
				/**
				 * The updateDataFromReverseSearchRequest function already checks
				 * the postal code and adds error messages.
				 */
				if (response
					&& typeof response.address !== 'undefined'
					&& typeof response.address.postcode !== 'undefined'
				) {
					const zip = response.address.postcode;
					const $zipCityFieldInput = $('.zip_city_field input');

					if ($zipCityFieldInput.val() !== zip) {
						$zipCityFieldInput.val(zip);

						distributorFinder.zipCity = zip;
						distributorFinder.dirty = true;

						$zipCityFieldInput.parents('form').trigger('submit');
					}
				}
			})
			.fail(() => {
				distributorFinder.handleGeolocationMessages(DF.i18n.NoZipFound);
			})
			.always(() => {
				$('.js-df-search-use-location').find('.mdi')
					.toggleClass('mdi-map-marker-radius mdi-loading mdi-spin');
			});
	},
	geolocationError(error) {
		distributorFinder.isLoading = false;
		if (error.code === 3) {
			distributorFinder.handleGeolocationMessages(DF.i18n.NoZipFound);
		} else if (error.code === 1) {
			distributorFinder.handleGeolocationMessages(DF.i18n.GeoLocationPermission);
		} else {
			distributorFinder.handleGeolocationMessages(error.message);
		}
		$('.js-df-search-use-location').find('.icon')
			.toggleClass('icon-map-marker-radius icon-loading icon-spin');
	},
	handleGeolocation() {
		// Try HTML5 geolocation.
		if (navigator.geolocation) {
			$('.js-df-search-use-location').find('.icon').toggleClass('icon-map-marker-radius icon-loading icon-spin');

			const geolocationOptions = {
				enableHighAccuracy: true,
				timeout: 5000,
			};
			distributorFinder.isLoading = true;
			navigator.geolocation.getCurrentPosition(
				distributorFinder.geolocationSuccess,
				distributorFinder.geolocationError,
				geolocationOptions,
			);
		} else {
			// Browser doesn't support geolocation. Rise issue to user.
			$('.zip_city_field').append(`<div class="df-form-error">${DF.i18n.GeoLocationPermission}</div>`);
		}
	},
	handleGeolocationMessages(message) {
		const $zipCityField = $('.zip_city_field');

		$zipCityField.find('.df-zip-error').remove();
		$zipCityField.append(`<div class="df-zip-error">${message}</div>`);
	},
	handleZipCityChange() {
		if (!distributorFinder.googleApi) {
			setTimeout(() => {
				distributorFinder.handleZipCityChange();
			}, 300);
			return;
		}
		distributorFinder.isLoading = true;
		const geocoder = new distributorFinder.googleApi.maps.Geocoder();
		const address = distributorFinder.zipCity;
		geocoder.geocode({address}, (results, status) => {
			if (status === distributorFinder.googleApi.maps.GeocoderStatus.OK) {
				const {location} = results[0].geometry;
				distributorFinder.latitude = location.lat();
				distributorFinder.longitude = location.lng();

				// Get the reverse search for the needed data.
				$.ajax({
					url: `${DF.OSMGeocodeAPI}&lat=${distributorFinder.latitude}&lon=${distributorFinder.longitude}&zoom=17`,
				})
					.done(distributorFinder.updateDataFromReverseSearchRequest)
					.fail(() => {
						distributorFinder.handleGeolocationMessages(DF.i18n.NoZipFound);
					});
			}
		});
	},
};

$(document).on('ready', distributorFinder.init);
window.distributorFinder = distributorFinder;

// The distributor model.
const DistributorModel = Backbone.Model.extend({
	defaults() {
		return {
			id: false,
			name: false,
			address: false,
			city: false,
			state: false,
			phone: false,
			url: false,
			distance: false,
			zip: false,
		};
	},
});

// Backbone distributors Collection.
const DistributorCollection = Backbone.Collection.extend({
	model: DistributorModel,
});
const Distributors = new DistributorCollection();

/**
 * The single distributor view.
 */
class DistributorView extends Backbone.View {
	get template() { // eslint-disable-line
		return _.template($('#df-search-results-item-template').html());
	}

	get className() { // eslint-disable-line
		return 'df-search-results-item';
	}

	get id() { // eslint-disable-line
		return `df-search-results-item-${this.model.get('id')}`;
	}

	initialize() {
		this.listenTo(this.model, 'change', this.render);
		this.listenTo(this.model, 'destroy', this.remove);
	}

	render() {
		this.$el.html(this.template(this.model.toJSON()));
		return this;
	}
}

/**
 * The distributors list view.
 */
class DistributorsView extends Backbone.View {
	get className() { // eslint-disable-line
		return 'df-search-results-items';
	}

	initialize() {
		this.collection.on('add', this.addOne, this);
		this.collection.on('reset', this.addAll, this);
		this.collection.on('sort', this.addAll, this);
	}

	render() {
		this.addAll();
		return this;
	}

	addAll() {
		this.$el.empty();
		this.collection.forEach((distributor, index) => {
			if (typeof distributor.letter === 'undefined') {
				distributor.set('letter', distributorFinder.letters[index]);
			}
			this.addOne(distributor);
		}, this);
	}

	addOne(distributor) {
		const distributorView = new DistributorView({model: distributor});
		this.$el.append(distributorView.render().el);
	}
}

/**
 * The whole results screen view.
 */
class DistributorFinderView extends Backbone.View {
	get template() { // eslint-disable-line
		return _.template($('#df-search-results-template').html());
	}

	get events() { // eslint-disable-line
		return {
			'submit .df-filters-form': DistributorFinderView.newSearch,
			'click .js-submit-df-filter': DistributorFinderView.toggleMobileFormClickEvent,
			'change .zip_city_field input': DistributorFinderView.zipCityChange,
			'change .application_field select': DistributorFinderView.applicationChange,
		};
	}

	static zipCityChange(changeEvent) {
		const value = $(changeEvent.currentTarget).val();
		if (value === distributorFinder.zipCity) {
			return;
		}
		distributorFinder.zipCity = value;
		distributorFinder.dirty = true;
		// If we actualy have a zip code, make the location search.
		if (value) {
			distributorFinder.handleZipCityChange();
		}
	}

	static applicationChange(changeEvent) {
		distributorFinder.dirty = true;
		distributorFinder.application = $(changeEvent.currentTarget).find(':selected').val();
	}

	static toggleMobileFormClickEvent(event) {
		event.preventDefault();
		DistributorFinderView.toggleMobileForm();
		const that = $('.js-submit-df-filter');
		// If we are closing the drawer also submit the form.
		if (!that.hasClass('open')) {
			$(`#gform_${DF.filterFormId}`).submit();
		}
	}

	static toggleMobileForm() {
		const that = $('.js-submit-df-filter');
		that.toggleClass('open');
	}

	static newSearch(event) {
		event.preventDefault();
		// If we don't have the needed data, just abort.
		if (!distributorFinder.application
			|| !distributorFinder.zipCity
			|| !distributorFinder.dirty
		) {
			return;
		}
		if (distributorFinder.isLoading) {
			setTimeout(DistributorFinderView.newSearch, 100, event);
			return;
		}
		if ($('.js-submit-df-filter').hasClass('open')) {
			DistributorFinderView.toggleMobileForm();
		}
		distributorFinder.clearMarkers();
		Distributors.url = DistributorFinderView.buildTheSearchUrl();
		distributorFinder.isLoading = true;
		Distributors.fetch({
			reset: true,
			success: distributorFinder.distributorsApiSuccessEvent,
		});
	}

	static buildTheSearchUrl() {
		const application = encodeURIComponent(distributorFinder.application);
		const country = encodeURIComponent(distributorFinder.country);
		const regionState = encodeURIComponent(distributorFinder.regionState);
		const streetAddress = encodeURIComponent(distributorFinder.streetAddress);
		const postalCode = encodeURIComponent(distributorFinder.postalCode);
		const lng = encodeURIComponent(distributorFinder.longitude);
		const lat = encodeURIComponent(distributorFinder.latitude);
		return `${DF.apiBase}?application=${application}&country=${country}&region_state=${regionState}&street_address=${streetAddress}&postal_code=${postalCode}&lat=${lat}&lng=${lng}`;
	}

	render() {
		this.$el.html(this.template({zipCity: distributorFinder.zipCity}));
		this.$el
			.find('#df-search-results-form-gform')
			.html($('#df-search-results-form-filters-template').html());

		// Get the distributors.
		Distributors.url = DistributorFinderView.buildTheSearchUrl();
		distributorFinder.isLoading = true;
		Distributors.fetch({
			success: distributorFinder.distributorsApiSuccessEvent,
		});
		return this;
	}
}

export default DistributorFinderView;
